var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22672 5.07422C2.0819 5.35103 2 5.66596 2 6.00002V16C2 17.1046 2.89543 18 4 18H12C12 14.6863 14.6863 12 18 12C19.5367 12 20.9385 12.5777 22 13.5278V6.00002C22 5.66596 21.9181 5.35103 21.7733 5.07422L13.577 10.8116C12.6301 11.4744 11.3699 11.4744 10.423 10.8116L2.22672 5.07422Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5731 4.08333C20.3916 4.02912 20.1992 4 20 4H4C3.80082 4 3.60844 4.02912 3.42688 4.08333L11.2832 9.58273C11.7136 9.88401 12.2864 9.88401 12.7168 9.58273L20.5731 4.08333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.75C15.4142 19.75 15.75 19.4142 15.75 19V18C15.75 17.3096 16.3096 16.75 17 16.75H19.1893L18.4697 17.4697C18.1768 17.7626 18.1768 18.2374 18.4697 18.5303C18.7626 18.8232 19.2374 18.8232 19.5303 18.5303L21.5303 16.5303C21.8232 16.2374 21.8232 15.7626 21.5303 15.4697L19.5303 13.4697C19.2374 13.1768 18.7626 13.1768 18.4697 13.4697C18.1768 13.7626 18.1768 14.2374 18.4697 14.5303L19.1893 15.25H17C15.4812 15.25 14.25 16.4812 14.25 18V19C14.25 19.4142 14.5858 19.75 15 19.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReply);
export default __webpack_public_path__ + "static/media/message-reply.4079571b08d9943494dac6e086d2b5f5.svg";
export { ForwardRef as ReactComponent };